// extracted by css-extract-rspack-plugin
export default {"root":"HJ_Wy","section":"wteKm","divided":"NkPU2","stack":"bdFwQ"};